import type React from 'react';

import { RepeatIcon, SettingsIcon } from '@vlabs/icons';
import { ButtonScrimGroup, Control } from '@vlabs/uikit';

import { ImageChecksProcessingImage } from './ImageChecksProcessingImage';
import st from './ImageControl.module.sass';
import { useImageCheckForm } from '../image-check-form';
import { cloneFileList } from '../image-check-form/cloneFileList';
import type { UseTaskDataReturn } from '../useTaskData';

function ImageControl({
  taskData,
}: {
  taskData: UseTaskDataReturn;
}): React.JSX.Element | null {
  const file = taskData.data?.fileList?.[0];
  const newImageCheckForm = useImageCheckForm({
    ...taskData.data,
    fileList: undefined,
  });
  const existedImageCheckForm = useImageCheckForm({
    ...taskData.data,
    fileList: cloneFileList(taskData.data?.fileList),
  });
  if (!file) return null;

  return (
    <div className={st.Root}>
      <ImageChecksProcessingImage file={file} />
      <div className={st.Controls}>
        {newImageCheckForm.wrap(({ onClick }) => (
          <ButtonScrimGroup>
            <Control.IconButton
              icon={<RepeatIcon />}
              kind="secondary"
              onClick={onClick}
              variant="flat"
            />
          </ButtonScrimGroup>
        ))}
        {existedImageCheckForm.wrap(({ onClick }) => (
          <ButtonScrimGroup>
            <Control.IconButton
              icon={<SettingsIcon />}
              kind="secondary"
              onClick={onClick}
              variant="flat"
            />
          </ButtonScrimGroup>
        ))}
      </div>
    </div>
  );
}

export { ImageControl };
